module.exports = __webpack_public_path__ + "static/logo-c2628f2bb76d8f034e1a844106aa1efc.png";